import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  compose,
  setPropTypes,
  withState,
  withHandlers,
  lifecycle
} from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import Drawer from '@material-ui/core/Drawer';
import Paper from '@material-ui/core/Paper';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import Header from '../../components/Header';
import MenuDrawer from '../../components/MenuDrawer';
import SearchButton from '../../components/atoms/SearchButton';
import GroupLinkTable from '../organisms/GroupLinkTable';
import { isAuthenticated, sendLogin } from '../../auth/Auth';
import { getGroups } from '../../actions/Groups';

const styles = {
  root: {
    backgroundColor: '#e0e0e0',
    flexGrow: 1,
    width: '100%'
  },
  pageTitileDiv: {
    paddingLeft: 20,
    paddingTop: 2,
    textAlign: 'left',
    backgroundColor: '#fff'
  },
  mainPaper: {
    position: 'relative',
    margin: 20
  },
  zoom: {
    position: 'relative',
    left: -10,
    top: 20
  },
  mainPaperTitleDiv: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'space-between',
    padding: '20px 26px 10px 26px'
  },
  searchForm: {
    padding: '10px 26px 10px 26px'
  },
  textField: {
    padding: '0px 5px 0px 5px',
    width: '300px'
  }
};

const propTypes = {
  classes: PropTypes.object.isRequired
};

const enhance = compose(
  connect(
    state => ({
      account: state.accounts.account,
      name: state.loginInfo.name
    }),
    dispatch => ({
      actions: bindActionCreators({ getGroups }, dispatch)
    })
  ),
  setPropTypes(propTypes),
  withState('openEditModal', 'updateOpenEditModal', false),
  withState('openDrawer', 'updateOpenDrawer', false),
  withState('openDelete', 'updateOpenDelete', false),
  withState('openTable', 'updateOpenTable', false),
  withState('loading', 'updateLoading', false),
  withState('openProgress', 'updateOpenProgress', false),
  withState('groupName', 'setGroupName', ''),
  withState('page', 'setPage', 1),
  withState('rowsPerPage', 'setRowsPerPage', 100),
  withHandlers({
    checkSession: props => data => {
      if (data.error === true && data.payload.status === 403) {
        sendLogin(props);
      }
      return data;
    },
    handleChangePage: props => async (event, page, limit) => {
      const table = document.getElementById('scrollTableId');
      if (table !== null) {
        table.scrollTop = 0;
      }
      props.setPage(page);

      const rowsPerPage = document.getElementById('rowsPerPage');
      let limitNum = 100;
      if (rowsPerPage) {
        limitNum = rowsPerPage.textContent;
      }

      const searchKey = {
        groupName: props.groupName,
        page,
        limit: limit || limitNum
      };

      props.updateLoading(true);
      props.updateOpenProgress(true);
      await props.actions.getGroups(searchKey).then(data => {
        if (data.error === true && data.payload.status === 403) {
          sendLogin(props);
        }
        return data;
      });
      props.updateLoading(false);
    }
  }),
  lifecycle({
    componentDidMount() {
      isAuthenticated(this.props);
    }
  })
);

const Main = enhance(
  ({
    classes,
    handleChangePage,
    account,
    name,
    openDrawer,
    updateOpenDrawer,
    openTable,
    updateOpenTable,
    groupName,
    setGroupName,
    page
  }) => {
    const searchAction = async () => {
      updateOpenTable(true);
      const rowsPerPage = document.getElementById('rowsPerPage');
      let limitNum = 100;
      if (rowsPerPage) {
        limitNum = rowsPerPage.textContent;
      }
      handleChangePage(null, 1, limitNum);
      // await actions.getGroups(searchKey).then(data => checkSession(data));
      // handleChangePage(null, 0);
      // updateOpenTable(true);
    };
    return (
      <div className={classes.root}>
        <Header
          name={name}
          onMenuClick={() => {
            updateOpenDrawer(true);
          }}
        />
        <Drawer
          open={openDrawer}
          anchor="left"
          onClose={() => {
            updateOpenDrawer(false);
          }}
        >
          <div tabIndex={0} role="button">
            <MenuDrawer account={account} />
          </div>
        </Drawer>
        <div className={classes.pageTitileDiv}>
          <Typography variant="h6" color="textSecondary">
            グループ運営会社検索
          </Typography>
        </div>
        <Paper className={classes.mainPaper} elevation={1}>
          <div className={classes.searchForm}>
            <div>
              <TextField
                label="運営会社名"
                placeholder="部分一致"
                type="search"
                className={classes.textField}
                margin="normal"
                value={groupName}
                onChange={e => {
                  setGroupName(e.target.value);
                }}
              />
            </div>
            <div>
              <SearchButton onClickAction={searchAction} />
            </div>
          </div>
          {openTable && (
            <GroupLinkTable
              page={page}
              handleChangePage={handleChangePage}
              selectedPage={page}
            />
          )}
        </Paper>
      </div>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
